(function($) {
    var __ = {
        body: $('body'),
        window: $(window),
        // Scene Controller
        controller: window._animations.base.controller,
        global: window._animations.base,
        ajax :  {},
        fetch: new ScrollMagic.Scene(),
        
        splitText : {},
        // Function that runs on load
        loadAnimations: function() {

            __.pageLoadEffects();

            if (__.global.screen === "large") {
                __.pageEffects();
            }
        },
        pageLoadEffects: function(block){
            var timeline = new TimelineMax();

            __.splitText.banner_title =  __.global.splitText($( '.pg-single-banner--title' ));
            if (__.global.screen === "large") {
              

                 timeline
                .add(TweenMax.from('.pg-header--logo', 0.4, __.global.animations.fade.down), '+=1')
                .add(TweenMax.from('.pg-navigation', 0.4, __.global.animations.slide.right) )
                .add(TweenMax.from('.pg-toggle--animation', 0.2, __.global.animations.fade.down), '+=0.2')
                
                .add(TweenMax.from($('.pg-single-banner--background'), 0.4, {opacity: 0} ) )
                .add(TweenMax.from('.pg-header--social', 0.4, __.global.animations.fade.left) )

                .add(TweenMax.from('.pg-single-banner--headline', 0.4, __.global.animations.slide.up ) )
                .add(TweenMax.from('.pg-single-banner--divider', 0.2, {width: 0}) )
                .add(TweenMax.from('.pg-single-banner--date', 0.4, __.global.animations.slide.up ) );

                __.global.staggerDisplay( __.splitText.banner_title, timeline);

                /* timeline
                .add(TweenMax.from('.pg-single-content', 0.4, __.global.animations.slide.up) )
                .add(TweenMax.from('.pg-single-content--container', 0.4, __.global.animations.fade.up) ) */
                timeline
                .call(function() {
                    __.global.completeLoadInAnimation();
                    __.splitText.banner_title.revert();
                });
            }else{

                timeline
                .add(TweenMax.from('.pg-header--logo', 0.4, __.global.animations.fade.down), '+=1')
                .add(TweenMax.from('.pg-navigation', 0.4, __.global.animations.fade.down) )
                .add(TweenMax.from('.pg-toggle--animation', 0.2, __.global.animations.fade.down), '+=0.2')
                
                .add(TweenMax.from($('.pg-single-banner--background'), 0.4, {opacity: 0} ) )
                .add(TweenMax.from('.pg-single-banner--headline', 0.4, __.global.animations.slide.up ) )
                .add(TweenMax.from('.pg-single-banner--divider', 0.2, {width: 0}) )
                .add(TweenMax.from('.pg-single-banner--date', 0.4, __.global.animations.slide.up ) );

                __.global.staggerDisplay( __.splitText.banner_title, timeline);

                /* timeline
                .add(TweenMax.from('.pg-single-content', 0.4, __.global.animations.slide.up) )
                .add(TweenMax.from('.pg-single-content--container', 0.4, __.global.animations.fade.up) ) */
                timeline
                .call(function() {
                    __.global.completeLoadInAnimation();
                    __.splitText.banner_title.revert();
                });
            }
            timeline.play(); //
        },
        pageEffects: function(){   
            // if (__.global.screen === "large") {
                __.loadImageGalleryBlocksDesktop();
            // }
            __.loadBottom();
            __.bannerParallax();
        },
        loadImageGalleryBlocksDesktop : function(){
            var galleries = $('.section-gallery');
            // Loop over each gallery
            galleries.each(function() {
                // within the gallery find all the images.
                var images = $(this).find('.gallery-image.desktop');
                var numImg = images.length;
                var imgAspectRatio = 0.7;
                var sectionGalleryWidth = $('.section-gallery').width();
                
                
                //initialize elements width and height, set them to end status, ie. to take full screen
                var viewportWidth = document.documentElement.clientWidth;
                var viewportHeight = document.documentElement.clientHeight;
                var endLeft = - (viewportWidth - sectionGalleryWidth) / 2;
                $('.gallery-image-container').css({width: viewportWidth, height: viewportHeight, left: endLeft});
                $('.gallery-text-container').css({width: viewportWidth, height: viewportHeight, left: endLeft});
                // $('.gallery-scroll-indicator').css({height: viewportHeight, right: endLeft});

                var sectionGalleryHeight = $('.section-gallery').height();
                var lastImageMarginBottom = parseInt($('.gallery-image-container').last().css('margin-bottom'));
                var singleImageOuterHeight = $(".gallery-image-container:not('.gallery-placeholder-container')").first().outerHeight(true); //including image margin
                var placeholderOuterHeight = $('.gallery-placeholder-container').outerHeight(true);
                // console.log('sectionGalleryHeight', sectionGalleryHeight);
                // console.log('placeholderOuterHeight', placeholderOuterHeight);
                // console.log('singleImageOuterHeight', singleImageOuterHeight);

                //pin .gallery-text-container
                var fixedElementPinDur = sectionGalleryHeight + lastImageMarginBottom - singleImageOuterHeight;
                // console.log('fixedElementPinDur', fixedElementPinDur);
                new ScrollMagic.Scene({
                    duration: fixedElementPinDur,
                    triggerElement: this,
                    triggerHook: 0,
                    offset: 0
                })
                .setPin('.gallery-text-container')
                // .addIndicators({name: "pinTextContainer"}) 
                .addTo(__.controller);

                //pin .scroll-indicator
                // new ScrollMagic.Scene({
                //     duration: fixedElementPinDur,
                //     triggerElement: this,
                //     triggerHook: 0,
                //     offset: 0
                // })
                // .setPin('.gallery-scroll-indicator')
                // // .addIndicators({name: "pinTextContainer"}) 
                // .addTo(__.controller);

                //update .scroll-indicator height
                // $(window).on('scroll', function(){
                //     var windowScrolled = $(window).scrollTop();
                //     var sectionGalleryTop = $('.section-gallery').offset().top;
                //     var scrolledPercent = 0;
                //     if(windowScrolled <= sectionGalleryTop) {
                //         scrolledPercent = 0;
                //     } else if (windowScrolled > (sectionGalleryTop + fixedElementPinDur)) {
                //         scrolledPercent = '100%';
                //     } else {
                //         scrolledPercent = ((windowScrolled - sectionGalleryTop) * 100 / fixedElementPinDur) + '%';
                //     }
                //     // console.log('scrolled percent', scrolledPercent);
                //     $('.scroll-indicator').css('height', scrolledPercent);
                    
                // });
                
                
                images.each(function (i) {
                    
                    //pin each gallery image except for the last one
                    var imagePinDur;
                    if(i < numImg - 1) {
                        imagePinDur = singleImageOuterHeight * (numImg - i - 1) ;
                        new ScrollMagic.Scene({
                            duration: imagePinDur,
                            triggerElement: this,
                            triggerHook: 0,
                            offset: 0
                        })
                        .setPin(this)
                        // .addIndicators({name: "pinImage"}) 
                        .addTo(__.controller);
                    }

                    //tween each .gallery-image-container
                    var startWidth, startHeight, startLeft, triggerHook, dur;
                    var galleryImageContainer = $(this).parents('.gallery-image-container').get(0);
                    var tweenImageContainer = new TimelineMax();
                    if(i === 0) {
                        startWidth = sectionGalleryWidth;
                        startHeight = startWidth * imgAspectRatio;
                        startLeft = 0;
                        triggerHook = 0.5;
                        dur = "50%";
                        tweenImageContainer.add(TweenMax.from(galleryImageContainer, 2, {width: startWidth, height: startHeight, left: startLeft, ease: Linear.easeNone} ));
                        new ScrollMagic.Scene({
                            duration: dur,
                            triggerElement: galleryImageContainer,
                            triggerHook: triggerHook,
                            offset: 0
                        })
                        .setTween(tweenImageContainer)
                        // .addIndicators({name: "tweenImageContainer"}) 
                        .addTo(__.controller);

                    } else {
                        startWidth = viewportWidth - 300;
                        startHeight = startWidth * imgAspectRatio;
                        startLeft = (sectionGalleryWidth - startWidth) / 2 ;
                        triggerHook = 0.7;
                        dur = "70%";
                        var numFrame = $(this).attr('data-frame');
                        var prevFrame = numFrame - 1;
                        var fadeinTextFrame = $('.gallery-text-frame[data-frame=' + numFrame + ']');
                        var prevTextFrame = $('.gallery-text-frame[data-frame=' + prevFrame + ']');
                        var fadeinText = fadeinTextFrame.find('.image-text');
                        var fadeoutTextFrame = $('.gallery-text-frame[data-frame!=' + numFrame + ']');
                        
                        tweenImageContainer.add(TweenMax.from(galleryImageContainer, 2, {width: startWidth, height: startHeight, left: startLeft, ease: Linear.easeNone} ));
                        tweenImageContainer.add(TweenMax.to(fadeinTextFrame, 2, {opacity: 1}), '-=2');
                        tweenImageContainer.add(TweenMax.from(fadeinText, 2, {y: -120}), '-=2');
                        tweenImageContainer.add(TweenMax.to(fadeoutTextFrame, 2, {opacity: 0}), '-=2');

                        new ScrollMagic.Scene({
                            duration: dur,
                            triggerElement: galleryImageContainer,
                            triggerHook: triggerHook,
                            offset: 0
                        })
                        .setTween(tweenImageContainer)
                        // .addIndicators({name: "tweenImageContainer"}) 
                        .addTo(__.controller);

                        //toggle .gallery-text-frame active class
                        new ScrollMagic.Scene({
                            duration: dur,
                            triggerElement: galleryImageContainer,
                            triggerHook: 0.5, 
                            offset: 0
                        })
                        .on('enter', function(event){
                            if(event.scrollDirection === 'FORWARD') {
                                //when scroll forward, add active class to fadein frame when its top hits middle of screen. 
                                fadeinTextFrame.addClass('active');
                                fadeoutTextFrame.removeClass('active');
                            } 
                        })
                        .on('leave', function(event) {
                            if(event.scrollDirection === 'REVERSE') {
                                //When scroll backward, remove active class for leaving frame when its top leaves middle of screen
                                fadeinTextFrame.removeClass('active');
                                if(prevTextFrame.length) {
                                    prevTextFrame.addClass('active');
                                }
                            } 
                        })
                        // .addIndicators({name: "add active class"}) 
                        .addTo(__.controller);

                    } 



                });

            });
            
        },
        bannerParallax : function(){
            var timeline = new TimelineMax();
            var banner = $('.pg-single-banner--background');
            timeline.add(TweenMax.to( banner, 0.4, { transform: 'translateY(350px)', ease:Linear.easeNone } ) );
            new ScrollMagic.Scene({
                duration: 700,
                offset: 0,
                triggerHook: 0,
            })               
            .setTween( timeline )
            .addTo(__.controller);
        },
        loadBottom : function(){

            var timeline = new TimelineMax();
            timeline
            .add(TweenMax.from('.pg-single-newsletter', 0.4, __.global.animations.fade.up) )
            .add(TweenMax.from('.pg-single-newsletter', 0.4, {background: '#ef4035' }) )
            .staggerFrom(__.global.prepareText( $('.pg-single-newsletter--label') ), 0.4, __.global.animations.slide.up, 0, '-=0.2')
            .add(TweenMax.from('.pg-single-newsletter--form', 0.4, __.global.animations.slide.up, 0, '-=0.2'))
            
            .add(TweenMax.from('.pg-single-author', 0.4, __.global.animations.slide.left ) )
            .staggerFrom(__.global.prepareText( $('.pg-single-author--title') ), 0.4, __.global.animations.slide.up, 0, '-=0.2')
            .add(TweenMax.from('.pg-single-author--button', 0.4, __.global.animations.slide.up ) )
            .add(TweenMax.from('.pg-single-author--button--line', 0.4, {left: '100%'} ) )

            
            .add(TweenMax.from('.pg-single-share', 0.4, __.global.animations.slide.right ) )
            
            .staggerFrom(__.global.prepareText( $('.pg-single-share--label') ), 0.4, __.global.animations.slide.up, 0, '-=0.2')
            .staggerFrom($('.pg-single-share--link'), 0.4, __.global.animations.fade.up, 0.2, '-=0.2');

            new ScrollMagic.Scene({
                duration: 200,
                offset: 150,
                triggerHook: 1,
                triggerElement: '.pg-single-meta'
            })              
            .setTween( timeline )
            .addTo(__.controller);
        },
        
        // Function to call to setup functionality
        setup: function() {
            __.loadAnimations();
        }
    };
    // Attach Toolbox to window 
    if (typeof window._animations === "undefined") {
        window._animations = {};
    }
    window._animations.single = __;
})(jQuery); // Fully reference jQuery after this point.